import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import CardMaisFiltros from '@/views/parecer/components/consulta/CardMaisFiltros.vue';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import CustomChip from '@/views/components/CustomChip.vue';
import { OPERADORES } from '@/constants/operadores';

interface IOperador {
  operador: string;
  tooltip: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardParametrosConsulta',
  setup(__props) {

const store = ConsultaParecerStore();
const { filtroParecer } = storeToRefs(store);

const handleClickTermos = (termo: IOperador) => {
  let dePesquisa = filtroParecer.value.dePesquisaTermos;

  const { operador } = termo;

  switch (operador) {
    case 'Aspas':
      dePesquisa = dePesquisa ? '"' + dePesquisa + '"' : '""';
      break;
    case 'Interrogacao':
      dePesquisa = dePesquisa ? dePesquisa + '?' : '?';
      break;
    case 'Asterisco':
      dePesquisa = dePesquisa ? dePesquisa + '*' : '*';
      break;
    default:
      dePesquisa = dePesquisa ? `${dePesquisa} ${operador} ` : operador;
  }

  filtroParecer.value = {
    ...filtroParecer.value,
    dePesquisaTermos: dePesquisa,
  };
};

return { __sfc: true,store, filtroParecer, handleClickTermos, CardMaisFiltros, CustomChip, OPERADORES }
}

})